import axios from 'axios';

export const load = () => axios.get('/api/corporate-leads');
export const save = (payload) => {
  if (payload.seq) {
    return axios.patch(`/api/corporate-leads?seq=${payload.seq}`, payload);
  } else {
    return axios.post('/api/corporate-leads', payload);
  }
};
export const findBySeq = (seq) => axios.get(`/api/corporate-leads?seq=${seq}`);
export const findAllFSCs = (branchCode) => axios.get(`/api/fscs?branch-code=${branchCode}`);
